import React from 'react';
import { IconProps } from '.';

const SvgHomeIn = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M12 1.498 1.502 10.805 2 12.117h1.75V13h1.5v-2.383H3.976l8.023-7.115 8.024 7.115H18.75V20.75H5.25V20h-1.5v2.25h16.5V12.117H22l.497-1.312L12 1.498Z'
      />
      <path
        fill={color}
        d='m11.54 16.113-3.175 3.175-1.06-1.06 1.363-1.364H3.75v-1.5H8.67L7.305 14l1.06-1.06 3.174 3.173Z'
      />
    </svg>
  );
};

export default SvgHomeIn;
